<template>
  <v-app>
    <headerComponent />

    <v-main>
      <router-view />
    </v-main>

    <FooterComponent />
  </v-app>
</template>

<script>
import headerComponent from "./components/Comun/headerComponent.vue";
import FooterComponent from "./components/Comun/FooterComponent.vue";
export default {
  name: "App",
  components: {
    headerComponent,
    FooterComponent,
  },
  data: () => ({
    //
  }),
};
</script>
<style>
#app {
  /* background-image: url("/public/img/webp/background.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center; */
  min-height: 100vh;
}
.subtitle {
  /* text-transform: uppercase; */
}
.title {
  text-transform: uppercase;
}

body.port-modal-open #cdfsolo8-header,
body.port-modal-open #cdfsolo8-header-space,
body.port-modal-open #step-form-v3 .head {
  visibility: hidden !important;
}

body.servicios-modal-open #cdfsolo8-header,
body.servicios-modal-open #cdfsolo8-header-space {
  visibility: hidden !important;
}

body.ubicacion-modal-open #cdfsolo8-header,
body.ubicacion-modal-open #cdfsolo8-header-space {
  visibility: hidden !important;
}

.v-dialog.opaque-fullscreen-dialog {
  position: fixed !important;
  inset: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  height: 100dvh !important;
  background: #f8fafc !important;
}
</style>
